import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  cancelarRequisicionHttp,
  createRequisicionHttp,
  getEstatusRequisicionHttp,
  getEventosBitacoraHttp,
  getJefeInmediatoHttp,
  getRequisicionesHttp,
  getRequisicionPorIdHttp,
  mandarAutorizarHttp,
  marcarAtendidaHttp,
  procesoAutorizacionHttp,
  surtirDisponibleHttp,
} from "actions/requisiciones";
import { getUsuarioDatosPorIdHttp, getUsuarioPorIdHttp, getUsuariosHttp } from "actions/users";
import {
  asignarInventarioExistenteOnRequiHttp,
  createInventarioOnRequiHttp,
  getInventarioHttp,
} from "actions/inventario";
import { getTipoMovimientoHttp } from "actions/tipoMovimiento";
import { setUser } from "actions/auth";
import { getProveedoresInventarioHttp } from "actions/proveedores";
import { createCotizacionHttp } from "actions/cotizacion";
import { normalizarFilasInventario } from "modules/inventario/utils/inventarioNormalizar.utils";
import { FilaInventario } from "modules/inventario/types/inventario.types";
import { getUnidadesMedidaHttp } from "actions/unidadMedida";
import { getCategoriasHttp } from "actions/categorias";
import { getTipoProductosHttp } from "actions/tipoProducto";
import { getUbicacionesHttp } from "actions/ubicacion";

export interface DetalleProducto {
  id_inventario: string | number;
  nombre: string;
  clave: string;
  tipo_producto: string;
  precio_unitario: number;
  cantidad: number;
  precio_total: number;
}
interface Proveedor {
  id_proveedor: number;
  razon_social: string;
  nombre_comercial: string;
  contacto: string;
  correo: string;
  telefono: string;
}

interface ProveedorPorProducto {
  nombre_producto?: string;
  tipo_movimiento?: number;
  proveedores: Proveedor[];
}

export const useRequisicionIndividual = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const IdRequisicion = searchParams.get("r");
  const intl = useIntl();
  const navigate = useNavigate();

  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);
  const user = useSelector((state: StoreType) => state?.app?.user?.data);

  const [procesando, setProcesando] = useState<boolean>(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const [errorLogin, setErrorLogin] = useState(false);
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  const [requisicion, setRequisicion] = useState<any>(null);

  // Estados para la paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //Cotizacion por compras
  const [procesandoCotizacion, setProcesandoCotizacion] = useState<boolean>(false);
  //Mandar a autorizar
  const [procesandoMandarAutorizar, setProcesandoMandarAutorizar] = useState<boolean>(false);
  //surtir lo disponible
  const [procesandoSurtir, setProcesandoSurtir] = useState<boolean>(false);
  //Modal para autorizar
  const [isAlertOpenAutorizar, setIsAlertOpenAutorizar] = useState(false);
  const handleisAlertOpenAutorizar = () => setIsAlertOpenAutorizar(true);
  const handleisAlertCloseAutorizar = () => setIsAlertOpenAutorizar(false);

  const [accionRequisicion, setAccionRequisicion] = useState<string>("");

  //Modal de ver detalles de la cotización
  const [verCotizacion, setVerCotizacion] = useState<any>(null);
  const [isAlertOpenCotizacion, setIsAlertOpenCotizacion] = useState(false);
  const handleisAlertOpenCotizacion = () => setIsAlertOpenCotizacion(true);
  const handleisAlertCloseCotizacion = () => setIsAlertOpenCotizacion(false);

  // Estado para los proveedores por producto
  const [proveedoresPorProducto, setProveedoresPorProducto] = useState<
    Record<string, ProveedorPorProducto>
  >({});
  const [procesandoProveedores, setProcesandoProveedores] = useState<boolean>(false);
  const [jefeInmediato, setJefeInmediato] = useState<any>(null);

  const [tipoProductos, setTipoProductos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [inventarios, setInventarios] = useState<any[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<any[]>([]);
  const [ubicaciones, setUbicaciones] = useState<any[]>([]);
  const [almacenes, setAlmacenes] = useState<any[]>([]);
  const [productos, setProductos] = useState<any[]>([]);

  /* CREAR PRODUCTO NUEVO */
  const [procesandoInventario, setProcesandoInventario] = useState<boolean>(false);
  const [isAlertOpenCrearInventario, setIsAlertOpenCrearInventario] = useState(false);
  const handleisAlertCrearInventarioOpen = () => setIsAlertOpenCrearInventario(true);
  const handleisAlertCrearInventarioClose = () => setIsAlertOpenCrearInventario(false);

  const [procesandoModal, setProcesandoModal] = useState<boolean>(false);

  const [idDetalleRequisicion, setIdDetalleRequisicion] = useState<number>(0);

  /* SELECCIONAR PRODUCTO EXISTENTE */
  const [isAlertOpenListaSeleccionable, setIsAlertOpenListaSeleccionable] = useState(false);
  const handleisAlertOpenListaSeleccionable = () => setIsAlertOpenListaSeleccionable(true);
  const handleisAlertCloseListaSeleccionable = () => setIsAlertOpenListaSeleccionable(false);
  const [productoDetalle, setProductoDetalle] = useState<FilaInventario | null>(null);

  const formikInventario = useFormik({
    initialValues: {
      clave: "",
      nombre: "",
      precio: "",
      id_unidad_medida: "",
      id_categoria: "",
      id_ubicacion: "",
      id_tipo_producto: "",
      cantidad: "",
      maximos: "",
      minimos: "",
      punto_reorden: "",
    },
    validationSchema: Yup.object({
      clave: Yup.string(),
      nombre: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      precio: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_unidad_medida: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      id_categoria: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_ubicacion: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_tipo_producto: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      cantidad: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      maximos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      minimos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      punto_reorden: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
    }),
    validateOnMount: true,
    onSubmit: async (values) => { },
  });

  const isFieldValidInventario = (fieldName: keyof typeof formikInventario.values) => {
    return (
      formikInventario.touched[fieldName] &&
      !formikInventario.errors[fieldName] &&
      formikInventario.values[fieldName] &&
      formikInventario.values[fieldName] !== ""
    );
  };

  const getFieldColorInventario = (fieldName: keyof typeof formikInventario.values) => {
    return isFieldValidInventario(fieldName) ? "#00AB16" : undefined;
  };

  const handleAccionRequisicion = (
    event: React.MouseEvent<HTMLElement>,
    nuevaAccionRequisicion: string
  ) => {
    setAccionRequisicion(nuevaAccionRequisicion);
  };

  const getRequisicionPorId = useCallback(async (data: any) => {
    try {
      const response = await getRequisicionPorIdHttp(data);
      setRequisicion(response);
      if (response?.id_creador) {
        const jefe = await getJefeInmediatoHttp({ id_usuario_creador: response.id_creador } as any);
        setJefeInmediato(jefe);
      }
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getCategorias = useCallback(async (idTipoProducto?: number) => {
    try {
      const params = idTipoProducto ? { id_tipo_producto: idTipoProducto } : {};
      const categorias = await getCategoriasHttp(params);
      setCategorias(categorias);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getCatalogoInventario = useCallback(async () => {
    try {
      const productos = await getInventarioHttp();
      setProductos(productos);
      setInventarios(productos);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUnidadesMedida = useCallback(async () => {
    try {
      const unidadesMedida = await getUnidadesMedidaHttp();
      setUnidadesMedida(unidadesMedida);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUbicaciones = useCallback(async () => {
    try {
      const ubicaciones = await getUbicacionesHttp();
      setUbicaciones(ubicaciones);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getTipoProducto = useCallback(async () => {
    try {
      const tipoProductos = await getTipoProductosHttp();
      setTipoProductos(tipoProductos);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  // Handlers para la paginación
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const detallesRequisicionPaginados = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return requisicion?.detalles?.slice(startIndex, endIndex) || [];
  }, [requisicion?.detalles, page, rowsPerPage]);

  const getProveedoresPorProductos = useCallback(async (ids_inventario: number[]) => {
    try {
      setProcesandoProveedores(true);
      const data: any = await getProveedoresInventarioHttp(ids_inventario);
      setProveedoresPorProducto(data);
      setProcesandoProveedores(false);
    } catch (error) {
      setProcesandoProveedores(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || "Error al obtener proveedores");
      handleisAlertOpen();
    }
  }, []);

  //AUTORIZACIONES
  const enviarAutorizar = async (datos: any) => {
    try {
      setProcesando(true);
      await mandarAutorizarHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "general_enviado_autorizar_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_enviado_autorizar_error" }));
      handleisAlertOpen();
    }
  };
  const cancelarRequisicion = async (datos: any) => {
    try {
      setProcesando(true);
      await cancelarRequisicionHttp(datos);
      if (IdRequisicion) {
        await getRequisicionPorId({ id_requisicion: IdRequisicion });
      }
      setMensajeAlert(intl.formatMessage({ id: "general_cancelar_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_cancelar_error" }));
      handleisAlertOpen();
    }
  };

  const marcarAtendida = async (datos: any) => {
    try {
      setProcesando(true);
      await marcarAtendidaHttp(datos);
      if (IdRequisicion) {
        await getRequisicionPorId({ id_requisicion: IdRequisicion });
      }
      setMensajeAlert(intl.formatMessage({ id: "general_marcar_atendido_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_marcar_atendido_error" }));
      handleisAlertOpen();
    }
  };

  const surtirDisponible = async (datos: any) => {
    try {
      setProcesando(true);
      await surtirDisponibleHttp(datos);
      if (IdRequisicion) {
        await getRequisicionPorId({ id_requisicion: IdRequisicion });
      }
      setMensajeAlert(intl.formatMessage({ id: "general_surtido_correctamente" }));
      handleisAlertOpen();
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_surtido_error" }));
      handleisAlertOpen();
    }
  };

  const createInventarioOnRequi = async (datos: any) => {
    try {
      setProcesandoModal(true);
      const response: any = await createInventarioOnRequiHttp(datos);
      setRequisicion((prev: any) => {
        if (!prev) return prev;
        return {
          ...prev,
          detalles: prev.detalles.map((d: any) =>
            d.id === datos.id_requisicion_detalle
              ? { ...d, inventario: response.inventario ?? response }
              : d
          ),
        };
      });
      setMensajeAlert(intl.formatMessage({ id: "general_añadido_correctamente" }));
      formikInventario.resetForm();
      setIdDetalleRequisicion(0);
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_añadir_general" }));
      handleisAlertOpen();
    }
  };
  const actualizarProductoEnRequisicion = async (producto: FilaInventario): Promise<boolean> => {
    try {
      setProcesandoModal(true);
      const idInventario = Number(producto.registro?.id ?? producto.id);

      const response: any = await asignarInventarioExistenteOnRequiHttp({
        id_inventario: idInventario,
        id_requisicion_detalle: idDetalleRequisicion,
      });

      setRequisicion((prev: any) => {
        if (!prev) return prev;
        return {
          ...prev,
          detalles: prev.detalles.map((d: any) =>
            d.id === idDetalleRequisicion
              ? { ...d, inventario: response.inventario ?? response }
              : d
          ),
        };
      });

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      setIdDetalleRequisicion(0);
      handleisAlertCloseListaSeleccionable();
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
      return true;
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_actualizar_general" }));
      handleisAlertOpen();
      return false;
    }
  };

  const procesoAutorizacion = async (datos: any) => {
    const accion = datos.tipo_accion;
    try {
      setProcesando(true);
      await procesoAutorizacionHttp(datos);
      if (IdRequisicion) {
        await getRequisicionPorId({ id_requisicion: IdRequisicion });
      }
      const tipo_accion =
        accion == "autorizar"
          ? intl.formatMessage({ id: "general_autorizado_correctamente" })
          : accion == "rechazar"
            ? intl.formatMessage({ id: "general_rechazado_correctamente" })
            : accion == "enviar a dg"
              ? intl.formatMessage({ id: "general_enviando_dg_correctamente" })
              : accion == "mandar a daf"
                ? intl.formatMessage({ id: "general_mandar_daf_correctamente" })
                : "";
      setMensajeAlert(tipo_accion);
      handleisAlertOpen();
      setAccionRequisicion("");
      handleisAlertCloseAutorizar();
      setProcesando(false);
    } catch (error) {
      const tipo_accion_error =
        accion == "autorizar"
          ? intl.formatMessage({ id: "general_autorizado_error" })
          : accion == "rechazar"
            ? intl.formatMessage({ id: "general_rechazado_error" })
            : accion == "enviar a dg"
              ? intl.formatMessage({ id: "general_enviando_dg_error" })
              : accion == "mandar a daf"
                ? intl.formatMessage({ id: "general_mandar_daf_error" })
                : "";
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || tipo_accion_error);
      handleisAlertOpen();
    }
  };

  const crearCotizacion = async (datos: any) => {
    try {
      setProcesandoCotizacion(true);
      await createCotizacionHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "cotizacion_creada_correctamente" }));
      handleisAlertOpen();
      handleisAlertCloseCotizacion();
      setProcesandoCotizacion(false);
    } catch (error) {
      setProcesandoCotizacion(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "cotizacion_creada_error" }));
      handleisAlertOpen();
    }
  };

  const getJefeInmediato = useCallback(async (datos: any) => {
    try {
      const jefeInmediato = await getJefeInmediatoHttp(datos);
      setJefeInmediato(jefeInmediato);
    } catch (error) {
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const filasInventario = useMemo(
    () =>
      normalizarFilasInventario(inventarios, {
        textoActivo: intl.formatMessage({ id: "general_activo" }),
        textoInactivo: intl.formatMessage({ id: "general_inactivo" }),
      }),
    [inventarios, intl]
  );

  useEffect(() => {
    const cargarCatalogosIniciales = async () => {
      setProcesando(true);
      try {
        const catalogos: Promise<any>[] = [
          getCategorias(),
          getCatalogoInventario(),
          getUnidadesMedida(),
          getUbicaciones(),
          getTipoProducto(),
        ];
        if (IdRequisicion) {
          catalogos.push(getRequisicionPorId({ id_requisicion: IdRequisicion }));
        }
        await Promise.all(catalogos);
      } finally {
        setProcesando(false);
      }
    };

    cargarCatalogosIniciales();
  }, []);

  return {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    requisicion,
    detallesRequisicionPaginados,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    idUsuario,
    //cotizacion
    procesandoCotizacion,
    //autorizar
    procesandoMandarAutorizar,
    enviarAutorizar,
    procesoAutorizacion,
    //modal para autorizar
    isAlertOpenAutorizar,
    handleisAlertOpenAutorizar,
    handleisAlertCloseAutorizar,
    accionRequisicion,
    handleAccionRequisicion,
    setAccionRequisicion,
    //detalles cotización
    verCotizacion,
    setVerCotizacion,
    isAlertOpenCotizacion,
    handleisAlertOpenCotizacion,
    handleisAlertCloseCotizacion,
    proveedoresPorProducto,
    procesandoProveedores,
    getProveedoresPorProductos,
    crearCotizacion,
    jefeInmediato,
    getJefeInmediato,
    surtirDisponible,
    procesandoSurtir,
    marcarAtendida,
    //crear producto nuevo
    procesandoInventario,
    isAlertOpenCrearInventario,
    handleisAlertCrearInventarioOpen,
    handleisAlertCrearInventarioClose,
    formikInventario,
    getFieldColorInventario,
    unidadesMedida,
    ubicaciones,
    almacenes,
    createInventarioOnRequi,
    procesandoModal,
    setIdDetalleRequisicion,
    idDetalleRequisicion,
    //lista seleccionable de productos
    isAlertOpenListaSeleccionable,
    handleisAlertOpenListaSeleccionable,
    handleisAlertCloseListaSeleccionable,
    filasInventario,
    setProductoDetalle,
    productoDetalle,
    actualizarProductoEnRequisicion,
    categorias,
    tipoProductos,
    cancelarRequisicion,
  };
};
